module.exports = (__webpack_require__(11))(145);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/react-router-redux/lib/index.js from dll-reference vendor_lib
// module id = 197
// module chunks = 0